import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle } from '@material-ui/core';
import { ICreateValidateResponse } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { LoaderButton } from '../components/buttons/LoaderButton';
import { useFormSubmit } from '../hooks/useFormSubmit';
import { useSnackbarNotify } from '../hooks/useSnackbarNotify';
import { Try } from '../Try';

interface IProps extends DialogProps {
	title?: string;
	content: string | JSX.Element;
	acceptText: string;
	rejectText?: string;
	acceptF: () => Promise<Try<ICreateValidateResponse>>;
	accept: (id: string) => void;
	reject: VoidFunction;
	outOfContentText?: boolean;
}

export const AlertDialogWithCreateResponse = ({
	title,
	content,
	acceptText,
	rejectText,
	acceptF = () => Promise.resolve(new Try({ error: '', hasError: false, objectId: '' })),
	accept,
	reject,
	outOfContentText = false,
	...rest
}: IProps) => {
	const strings = useLocalization();
	const [submit, isSubmitting] = useFormSubmit(acceptF);
	const notify = useSnackbarNotify();

	const onSubmit = async () => {
		const r = await submit();
		if (r.isSuccess) {
			if (r.result.hasError) {
				notify(r.result.error, 'error');
			} else {
				accept(r.result.objectId!);
			}
		}
	};

	return (
		<Dialog
			fullWidth
			onClose={reject}
			{...rest}>
			{title && <DialogTitle>{title}</DialogTitle>}
			<DialogContent dividers>
				{outOfContentText === true && content}
				{outOfContentText === false && <DialogContentText style={{ whiteSpace: 'pre-line' }}>{content}</DialogContentText>}
			</DialogContent>
			<DialogActions>
				<Button
					onClick={reject}
					color='primary'>
					{rejectText ?? strings.cancel}
				</Button>
				<LoaderButton
					isLoading={isSubmitting}
					disabled={isSubmitting}
					onClick={onSubmit}
					color='primary'
					autoFocus>
					{acceptText}
				</LoaderButton>
			</DialogActions>
		</Dialog>
	);
};
